var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0112 9.12948V6.93847C16.0112 3.91331 13.5589 1.46094 10.5337 1.46094C7.50854 1.46094 5.05617 3.91331 5.05617 6.93847V9.12948M10.5337 14.0593V16.2503M7.02808 21.18H14.0393C15.8799 21.18 16.8002 21.18 17.5033 20.8218C18.1217 20.5067 18.6244 20.004 18.9395 19.3856C19.2977 18.6825 19.2977 17.7622 19.2977 15.9216V14.3879C19.2977 12.5473 19.2977 11.627 18.9395 10.9239C18.6244 10.3055 18.1217 9.80278 17.5033 9.48769C16.8002 9.12948 15.8799 9.12948 14.0393 9.12948H7.02808C5.18746 9.12948 4.26715 9.12948 3.56412 9.48769C2.94572 9.80278 2.44295 10.3055 2.12786 10.9239C1.76965 11.627 1.76965 12.5473 1.76965 14.3879V15.9216C1.76965 17.7622 1.76965 18.6825 2.12786 19.3856C2.44295 20.004 2.94572 20.5067 3.56412 20.8218C4.26715 21.18 5.18746 21.18 7.02808 21.18Z",
    strokeWidth: 2.19101,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.87ccf8b6.svg";
export { ForwardRef as ReactComponent };